import CityPageTemplate from "../city-template/CityPageTemplate";
import { greeleyConfig } from "./data";

export default function GreeleyPage() {
  return <CityPageTemplate config={greeleyConfig} />;
}